import React, { useContext, useState, useRef, useEffect } from "react";
import { Heading, Text, Flex, Image, Button, Box } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import AuthContext from "../Utils/auth";
import ReactPlayer from "react-player";
import { ChevronDownIcon } from "@chakra-ui/icons";
import "../index.css";
import {
  workbook_url,
  break_logo_light,
  fj_logo_dark_bg,
  landing_bg_img,
  video_1_url,
  video_2_url,
  video_3_url,
  landing_text,
  landing_text_report,
  landing_text_start,
  landing_text_resume,
  landing_text_progress,
  render_landing_objective,
  render_landing_takeaway,
  render_landing_action_step,
  bottom_text_report,
  bottom_text_start,
  bottom_text_progress,
} from "../theme";

const LandingNew = () => {
  const authCtx = useContext(AuthContext);
  const user = authCtx.name
    ? capitalizeFirstLetter(authCtx.name)
    : authCtx.name;
  const location = useLocation();
  const { parameter, staticData, origin_owner_email } = location.state || {};
  function capitalizeFirstLetter(name) {
    const words = name.split(" ");
    const capitalizedWords = words.map((word) => {
      return `${word.charAt(0).toUpperCase()}${word.slice(1)}`;
    });
    return capitalizedWords.join(" ");
  }

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const [width, setWidth] = useState(window.innerWidth);
  const isMobile = width <= 768;
  const videoWidth = isMobile ? "300px" : "550px";
  const videoHeight = isMobile ? "170px" : "310px";
  const video0Ref = useRef(null);
  const video1Ref = useRef(null);

  const handleRefButtonClick = (targetRef) => {
    if (targetRef && targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div ref={video0Ref} />
      <Flex
        minHeight="100vh"
        justifyContent="center"
        flexDir="column"
        bgImg={landing_bg_img}
        bgSize="cover"
        bgPosition="center"
        bgRepeat="no-repeat"
        alignItems="center"
        position="relative"
      >
        <Flex
          flexDir="column"
          alignItems="center"
          width={["90vw", "90vw", "90vw", "1200px", "1200px"]}
          justifyContent="center"
          flex="1"
        >
          {(() => {
            switch (parameter) {
              case "report":
                return (
                  <>
                    <Image
                      src={fj_logo_dark_bg}
                      alt="Logo"
                      width={["150px", "150px", "200px", "200px", "200px"]}
                      mb="20px"
                      mt="60px"
                    />
                    <Heading
                      fontFamily="Avenir"
                      color="white"
                      fontWeight="900"
                      width="85%"
                      textAlign="center"
                      fontSize={["24px", "24px", "24px", "32px", "32px"]}
                    >
                      YOUR BRAIN PATTERN MAP IS READY.
                    </Heading>

                    <Text
                      color="white"
                      textAlign="center"
                      mt="20px"
                      fontSize={["18px", "18px", "18px", "20px", "20px"]}
                      width={["85%", "85%", "85%", "700px", "700px"]}
                      mb="0px"
                    >
                      {landing_text_report}
                    </Text>
                  </>
                );
              case "start":
                return (
                  <>
                    <Image
                      src={fj_logo_dark_bg}
                      alt="Logo"
                      width={["150px", "150px", "200px", "200px", "200px"]}
                      my="20px"
                    />
                    <Heading
                      fontFamily="Avenir"
                      color="white"
                      fontWeight="900"
                      width="85%"
                      textAlign="center"
                      fontSize={["24px", "24px", "24px", "32px", "32px"]}
                    >
                      Welcome, {user}.
                    </Heading>
                    <Flex justifyContent="center">
                      <Text
                        color="white"
                        textAlign="center"
                        mt="20px"
                        fontSize={["18px", "18px", "18px", "20px", "20px"]}
                        width={["85%", "85%", "85%", "650px", "650px"]}
                      >
                        {landing_text_start()}
                      </Text>
                    </Flex>
                    <Flex mt="40px" mb="40px" gap="12px">
                      <a
                        href="/diagnostic"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Button
                          bg="yellow"
                          width="260px"
                          fontWeight="900"
                          fontSize={["12px", "12px", "12px", "16px", "16px"]}
                          m="auto"
                          as="a"
                          href="/diagnostic"
                          target="_blank"
                          _hover={{
                            bg: "#b2b200",
                          }}
                        >
                          START MY DIAGNOSTIC
                        </Button>
                      </a>
                    </Flex>
                  </>
                );
              case "progress":
                return (
                  <>
                    <Image
                      src={fj_logo_dark_bg}
                      alt="Logo"
                      width={["150px", "150px", "200px", "200px", "200px"]}
                      my="20px"
                    />
                    <Heading
                      fontFamily="Avenir"
                      color="white"
                      fontWeight="900"
                      width="85%"
                      textAlign="center"
                      fontSize={["24px", "24px", "24px", "32px", "32px"]}
                    >
                      Welcome back, {user}.
                    </Heading>
                    <Flex justifyContent="center">
                      <Text
                        color="white"
                        textAlign="center"
                        mt="20px"
                        fontSize={["18px", "18px", "18px", "20px", "20px"]}
                        width={["85%", "85%", "85%", "650px", "650px"]}
                      >
                        {landing_text_progress()}
                      </Text>
                    </Flex>
                    <Flex mt="40px" mb="40px" gap="12px">
                      <a
                        href="/diagnostic"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Button
                          bg="yellow"
                          width="260px"
                          fontWeight="900"
                          fontSize={["12px", "12px", "12px", "16px", "16px"]}
                          m="auto"
                          as="a"
                          _hover={{
                            bg: "#b2b200",
                          }}
                        >
                          COMPLETE MY DIAGNOSTIC
                        </Button>
                      </a>
                    </Flex>
                  </>
                );
            }
          })()}
        </Flex>
        <Flex
          alignItems="center"
          flexDir="column"
          width="100%"
          textAlign="center"
          justifyContent="center"
          cursor="pointer"
          py="2"
          onClick={() => handleRefButtonClick(video1Ref)}
        >
          <Flex alignItems="center" mb="50px">
            <Text
              color="white"
              fontSize={["12px", "12px", "12px", "14px", "14px"]}
            >
              POWERED BY
            </Text>
            <Image
              src={break_logo_light}
              alt="Logo"
              width={["150px", "150px", "200px", "200px", "200px"]}
            />
          </Flex>
          <Text
            color="white"
            fontSize={["12px", "12px", "12px", "14px", "14px"]}
          >
            BONUS VIDEOS BELOW
          </Text>
          <ChevronDownIcon w={6} h={6} color="white" />
        </Flex>
      </Flex>
      <>
        {/* ==== */}
        {/* VIDEO LECTURE 1 SECTION */}
        {/* ==== */}
        <div ref={video1Ref} />
        <Flex
          flexDir="column"
          justifyContent="center"
          width={["90vw", "90vw", "90vw", "1200px", "1200px"]}
          maxWidth={["90vw", "90vw", "90vw", "1200px", "1200px"]}
          m="auto"
          p="40px 0"
        >
          <Button
            bg="yellow"
            width="fit-content"
            fontWeight="900"
            fontSize={["12px", "12px", "12px", "16px", "16px"]}
            m="auto"
            as="a"
            href={workbook_url}
            target="_blank"
            _hover={{
              bg: "black",
              color: "white",
            }}
            whiteSpace="normal"
            textAlign="center"
          >
            STEP 1: DOWNLOAD YOUR BONUS WORKBOOK COMPANION
          </Button>
          {/* VIDEO TITLE */}
          <Heading
            fontFamily="Avenir"
            textAlign="left"
            fontWeight="900"
            fontSize={["22px", "22px", "22px", "28px", "28px"]}
            width="100%"
            mt="40px"
            lineHeight="1.5"
          >
            Step 2: Watch the video lecture on Timeline Processing
          </Heading>

          {/* ROW ITEM */}
          <Flex
            flexWrap="wrap"
            justifyContent="center"
            alignItems="center"
            flexDir={["column", "column", "column", "row", "row"]}
            m="40px 0px 80px 0px"
          >
            {/* TEXT ITEM */}
            <Flex
              flexDir="column"
              width={["100%", "100%", "100%", "50%", "50%"]}
            >
              <Heading
                fontFamily="Avenir"
                fontWeight="900"
                fontSize={["18px", "18px", "18px", "22px", "22px"]}
              >
                Objective
              </Heading>
              <Text
                fontSize={["16px", "16px", "16px", "18px", "18px"]}
                mt="10px"
              >
                {render_landing_objective(2)}
              </Text>
              <Heading
                fontFamily="Avenir"
                fontWeight="900"
                fontSize={["18px", "18px", "18px", "22px", "22px"]}
                mt="40px"
              >
                Takeaway
              </Heading>
              <Text
                fontSize={["16px", "16px", "16px", "18px", "18px"]}
                mt="10px"
              >
                {render_landing_takeaway(2)}
              </Text>
              <Heading
                fontFamily="Avenir"
                fontWeight="900"
                fontSize={["18px", "18px", "18px", "22px", "22px"]}
                mt="40px"
              >
                Action Step
              </Heading>
              <Text
                fontSize={["16px", "16px", "16px", "18px", "18px"]}
                mt="10px"
              >
                {render_landing_action_step(2)}
              </Text>
            </Flex>

            {/* VIDEO ITEM */}
            <Flex
              justifyContent="center"
              alignItems="center"
              flexDir="column"
              width={["100%", "100%", "100%", "50%", "50%"]}
              mt="40px"
            >
              <Flex
                width="fit-content"
                alignSelf={[
                  "center",
                  "center",
                  "center",
                  "flex-end",
                  "flex-end",
                ]}
                flexDir="column"
                alignItems="center"
              >
                <Flex
                  width={videoWidth}
                  height={videoHeight}
                  background="black"
                  alignSelf="flex-start"
                >
                  <ReactPlayer
                    url={video_1_url}
                    controls={true}
                    playbackRate={1.0}
                    config={{
                      vimeo: {
                        playerOptions: {
                          autopause: 0,
                          transparent: true,
                          loop: false,
                          muted: false,
                          portrait: false,
                          fullscreen: false,
                          seek: false,
                          responsive: true,
                          controls: true,
                          keyboard: true,
                          progress_bar: true,
                        },
                      },
                    }}
                  />
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        {/* ==== */}
        {/* END VIDEO LECTURE SECTION */}
        {/* ==== */}

        {/* ==== */}
        {/* VIDEO LECTURE 2 SECTION */}
        {/* ==== */}

        <Flex width="100%" bg="black" height="fit-content" position="relative">
          <Flex
            flexDir="column"
            justifyContent="center"
            width={["90vw", "90vw", "90vw", "1200px", "1200px"]}
            m="auto"
            p="40px 0"
          >
            {/* VIDEO TITLE */}
            <Heading
              fontFamily="Avenir"
              textAlign="left"
              fontWeight="900"
              fontSize={["22px", "22px", "22px", "28px", "28px"]}
              width="100%"
              mt="40px"
              color="white"
              lineHeight="1.5"
            >
              Step 3: Watch the video lecture on the Timeline Process Exercise
            </Heading>

            {/* ROW ITEM */}
            <Flex
              flexWrap="wrap"
              justifyContent="center"
              flexDir={[
                "column-reverse",
                "column-reverse",
                "column-reverse",
                "row",
                "row",
              ]}
              m="40px 0px 80px 0px"
              alignItems="center"
            >
              {/* VIDEO ITEM */}
              <Flex
                justifyContent="center"
                alignItems="center"
                mt="40px"
                flexDir="column"
                width={["100%", "100%", "100%", "50%", "50%"]}
              >
                <Flex
                  width="fit-content"
                  alignSelf={[
                    "center",
                    "center",
                    "center",
                    "flex-start",
                    "flex-start",
                  ]}
                  flexDir="column"
                  alignItems="center"
                >
                  <Flex
                    style={{
                      width: videoWidth,
                      height: videoHeight,
                      background: "black",
                      alignSelf: "flex-start",
                    }}
                  >
                    <ReactPlayer
                      url={video_2_url}
                      controls={true}
                      playbackRate={1.0}
                      config={{
                        vimeo: {
                          playerOptions: {
                            autopause: 0,
                            transparent: true,
                            loop: false,
                            muted: false,
                            portrait: false,
                            fullscreen: false,
                            seek: false,
                            responsive: true,
                            controls: true,
                            keyboard: true,
                            progress_bar: true,
                          },
                        },
                      }}
                    />
                  </Flex>
                </Flex>
              </Flex>

              {/* TEXT ITEM */}
              <Flex
                flexDir="column"
                width={["100%", "100%", "100%", "50%", "50%"]}
              >
                <Heading
                  fontFamily="Avenir"
                  fontWeight="900"
                  fontSize={["18px", "18px", "18px", "22px", "22px"]}
                  color="white"
                >
                  Objective
                </Heading>
                <Text
                  fontSize={["16px", "16px", "16px", "18px", "18px"]}
                  mt="10px"
                  color="white"
                >
                  {render_landing_objective(3)}
                </Text>
                <Heading
                  fontFamily="Avenir"
                  fontWeight="900"
                  fontSize={["18px", "18px", "18px", "22px", "22px"]}
                  mt="40px"
                  color="white"
                >
                  Takeaway
                </Heading>
                <Text
                  fontSize={["16px", "16px", "16px", "18px", "18px"]}
                  mt="10px"
                  color="white"
                >
                  {render_landing_takeaway(3)}
                </Text>
                <Heading
                  fontFamily="Avenir"
                  fontWeight="900"
                  fontSize={["18px", "18px", "18px", "22px", "22px"]}
                  mt="40px"
                  color="white"
                >
                  Action Step
                </Heading>
                <Text
                  fontSize={["16px", "16px", "16px", "18px", "18px"]}
                  mt="10px"
                  color="white"
                >
                  {render_landing_action_step(3)}
                </Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        {/* ==== */}
        {/* END VIDEO LECTURE SECTION */}
        {/* ==== */}

        {/* ==== */}
        {/* VIDEO LECTURE 3 SECTION */}
        {/* ==== */}
        <Flex width="100%" height="fit-content" position="relative">
          <Flex
            flexDir="column"
            justifyContent="center"
            width={["90vw", "90vw", "90vw", "1200px", "1200px"]}
            maxWidth={["90vw", "90vw", "90vw", "1200px", "1200px"]}
            m="auto"
            pt="40px"
          >
            {/* VIDEO TITLE */}
            <Heading
              fontFamily="Avenir"
              textAlign="left"
              fontWeight="900"
              fontSize={["22px", "22px", "22px", "28px", "28px"]}
              width="100%"
              mt="40px"
            >
              Step 4: Watch the video lecture on Source Belief Pattern
              Etiologies
            </Heading>

            {/* ROW ITEM */}
            <Flex
              flexWrap="wrap"
              justifyContent="center"
              flexDir={["column", "column", "column", "row", "row"]}
              alignItems="center"
              m="40px 0px 40px 0px"
            >
              {/* TEXT ITEM */}
              <Flex
                flexDir="column"
                width={["100%", "100%", "100%", "50%", "50%"]}
              >
                <Heading
                  fontFamily="Avenir"
                  fontWeight="900"
                  fontSize={["18px", "18px", "18px", "22px", "22px"]}
                >
                  Objective
                </Heading>
                <Text
                  fontSize={["16px", "16px", "16px", "18px", "18px"]}
                  mt="10px"
                >
                  {render_landing_objective(4)}
                </Text>
                <Heading
                  fontFamily="Avenir"
                  fontWeight="900"
                  fontSize={["18px", "18px", "18px", "22px", "22px"]}
                  mt="40px"
                >
                  Takeaway
                </Heading>
                <Text
                  fontSize={["16px", "16px", "16px", "18px", "18px"]}
                  mt="10px"
                >
                  {render_landing_takeaway(4)}
                </Text>
                <Heading
                  fontFamily="Avenir"
                  fontWeight="900"
                  fontSize={["18px", "18px", "18px", "22px", "22px"]}
                  mt="40px"
                >
                  Action Step
                </Heading>
                <Text
                  fontSize={["16px", "16px", "16px", "18px", "18px"]}
                  mt="10px"
                >
                  {render_landing_action_step(4)}
                </Text>
              </Flex>

              {/* VIDEO ITEM */}
              <Flex
                justifyContent="center"
                alignItems="center"
                mt="40px"
                flexDir="column"
                width={["100%", "100%", "100%", "50%", "50%"]}
              >
                <Flex
                  width="fit-content"
                  alignSelf={[
                    "center",
                    "center",
                    "center",
                    "flex-end",
                    "flex-end",
                  ]}
                  flexDir="column"
                  alignItems="center"
                >
                  <Flex
                    width={videoWidth}
                    height={videoHeight}
                    background="black"
                    alignSelf="flex-end"
                  >
                    <ReactPlayer
                      url={video_3_url}
                      controls={true}
                      playbackRate={1.0}
                      config={{
                        vimeo: {
                          playerOptions: {
                            autopause: 0,
                            transparent: true,
                            loop: false,
                            muted: false,
                            portrait: false,
                            fullscreen: false,
                            seek: false,
                            responsive: true,
                            controls: true,
                            progress_bar: true,
                          },
                        },
                      }}
                    />
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        {/* ==== */}
        {/* END VIDEO LECTURE SECTION */}
        {/* ==== */}

        {/* ==== */}
        {/* CTA SECTION */}
        {/* ==== */}
        <Flex
          justifyContent="center"
          alignItems="center"
          alignContent="center"
          my="40px"
        >
          {(() => {
            switch (parameter) {
              case "report":
                return (
                  <Button
                    bg="yellow"
                    width="300px"
                    fontWeight="900"
                    padding="10px 45px"
                    border="1px solid black"
                    onClick={() => handleRefButtonClick(video0Ref)}
                  >
                    {bottom_text_report}
                  </Button>
                );
              case "start":
                return (
                  <Flex gap="20px" alignItems="center" flexDir="column">
                    <Text
                      textAlign="center"
                      fontSize={["16px", "16px", "16px", "18px", "18px"]}
                      mt="10px"
                      fontWeight="500"
                    >
                      {bottom_text_start()}
                    </Text>
                    <a
                      href="/diagnostic"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button
                        bg="yellow"
                        width="260px"
                        fontWeight="900"
                        fontSize={["12px", "12px", "12px", "16px", "16px"]}
                        m="auto"
                        as="a"
                        href="/diagnostic"
                        target="_blank"
                        _hover={{
                          bg: "#b2b200",
                        }}
                      >
                        START MY DIAGNOSTIC
                      </Button>
                    </a>
                  </Flex>
                );
              case "progress":
                return (
                  <Flex gap="20px" alignItems="center" flexDir="column">
                    <Text
                      textAlign="center"
                      fontSize={["16px", "16px", "16px", "18px", "18px"]}
                      mt="10px"
                      fontWeight="bold"
                    >
                      {bottom_text_progress()}
                    </Text>
                    <a
                      href="/diagnostic"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button
                        bg="yellow"
                        width="260px"
                        fontWeight="900"
                        fontSize={["12px", "12px", "12px", "16px", "16px"]}
                        m="auto"
                        as="a"
                        href="/diagnostic"
                        target="_blank"
                        _hover={{
                          bg: "#b2b200",
                        }}
                      >
                        COMPLETE MY DIAGNOSTIC
                      </Button>
                    </a>
                  </Flex>
                );
            }
          })()}
        </Flex>
      </>
    </>
  );
};

export default LandingNew;
